import Axios, { AxiosRequestConfig } from "axios";
import Environment from "../../utils/Environement";

const proxy = (Environment.isDev)
    ? (Environment.isPopina) ? "https://us-central1-popina-dev.cloudfunctions.net/api/proxy/" : "https://us-central1-jalia-dev.cloudfunctions.net/api/proxy/"
    : (Environment.isPopina) ? "https://us-central1-popina-prod.cloudfunctions.net/api/proxy/" : "https://us-central1-jalia-prod.cloudfunctions.net/api/proxy/";

class BaseApi {

    private useProxy: boolean
    private timeout: number
    public readonly baseUrl: string

    constructor(baseUrl: string, useProxy: boolean = true, timeout = 10000) {
        this.baseUrl = baseUrl;
        this.useProxy = useProxy;
        this.timeout = timeout;
    }

    private config(header?: any): AxiosRequestConfig {
        return {
            'headers': header ?? {},
            'timeout': this.timeout,
            'timeoutErrorMessage': "Request cancelled by timeout ..."
        };
    }

    private url(target: string): string {
        return (this.useProxy)
            ? proxy + this.baseUrl + target
            : this.baseUrl + target;
    }

    protected getRequest(target: string, header?: any) {
        return Axios.get(this.url(target), this.config(header));
    }

    protected postRequest(target: string, header?: any, data?: any) {
        return Axios.post(this.url(target), data, this.config(header));
    }

    protected putRequest(target: string, header?: any, data?: any) {
        return Axios.put(this.url(target), data, this.config(header));
    }

    protected patchRequest(target: string, header?: any, data?: any) {
        return Axios.patch(this.url(target), data, this.config(header));
    }

    protected deleteRequest(target: string, header?: any) {
        return Axios.delete(this.url(target), this.config(header));
    }
}

export default BaseApi;